<template>
  <header :class="['glass-topbar', 'glass-topbar--wordmark', { 'is-open': isOpen, 'is-scrolled': isScrolled }]">
    <router-link class="glass-topbar__brand glass-topbar__brand--wordmark" :to="{ name: 'operator-events' }" @click="closeMenu">
      <img class="glass-topbar__brand-logo" src="/static/LOGOFOMO26_pro.png" alt="Fomo Planes" />
    </router-link>

    <button class="glass-topbar__menu-button" type="button" @click="toggleMenu">
      <i class="fas" :class="isOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

    <div class="glass-topbar__nav">
      <nav class="glass-topbar__links" :style="toolbarStyle">
        <div class="glass-topbar__toolbar">
          <div class="glass-topbar__indicator">
            <div class="glass-topbar__indicator-glow"></div>
            <div class="glass-topbar__indicator-clip">
              <div class="glass-topbar__indicator-ring"></div>
            </div>
            <div class="glass-topbar__indicator-plate"></div>
          </div>
        </div>

        <div v-for="item in navItems" :key="item.name" class="glass-topbar__link-wrap">
          <router-link :class="linkClass(item.name)" :to="item.to" @click="closeMenu">
            <i :class="['glass-topbar__link-icon', item.icon]"></i>
            <span class="glass-topbar__link-label">{{ item.label }}</span>
          </router-link>
        </div>
      </nav>

    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderOperator',

  computed: {
    navItems() {
      return [
        { name: 'operator-events', label: 'Eventos', icon: 'fas fa-calendar-check', to: { name: 'operator-events' } },
        { name: 'qr-reader', label: 'Scanner', icon: 'fas fa-qrcode', to: { name: 'qr-reader' } },
        { name: 'LogOut', label: 'Salir', icon: 'fas fa-sign-out-alt', to: { name: 'LogOut' } },
      ]
    },

    activeIndex() {
      const routeName = this.$route.name

      if (routeName === 'qr-reader' || routeName === 'qr-test') {
        return 1
      }

      if (routeName === 'LogOut') {
        return 2
      }

      return 0
    },

    toolbarStyle() {
      return {
        '--count': this.navItems.length,
        '--active-index': this.activeIndex,
      }
    },
  },

  data() {
    return {
      isOpen: false,
      isScrolled: false,
    }
  },

  mounted() {
    this.handleScroll()
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },

  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    handleScroll() {
      this.isScrolled = (window.scrollY || window.pageYOffset || 0) > 18
    },

    toggleMenu() {
      this.isOpen = !this.isOpen
    },

    closeMenu() {
      this.isOpen = false
    },

    linkClass(routeName) {
      const index = this.navItems.findIndex((item) => item.name === routeName)
      return ['glass-topbar__link', { 'is-active': index === this.activeIndex }]
    },
  },

  watch: {
    $route() {
      this.closeMenu()
    },
  },
}
</script>

<style scoped>
.glass-topbar--wordmark::before {
  content: none !important;
  display: none !important;
}

.glass-topbar--wordmark.is-scrolled::before {
  content: none !important;
  display: none !important;
}

.glass-topbar__brand--wordmark {
  gap: 0;
  flex-shrink: 0;
  max-width: 236px;
}

.glass-topbar__brand-logo {
  display: block;
  width: 100%;
  height: auto;
  filter: drop-shadow(0 10px 24px rgba(142, 111, 198, 0.22));
}

@media (max-width: 720px) {
  .glass-topbar__brand--wordmark {
    max-width: 168px;
  }
}
</style>
